import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  labels: {
    display: 'flex',
    gap: '4px',
    position: 'absolute',
    right: '12px',
    bottom: '12px',

    '@media screen and (min-width: 1441px)': {
      right: '16px',
      bottom: '16px',
    },
  },
}));

export default useStyles;
